import React, { FC } from 'react';

import LandingHero, {
  HeroImageSrcSet,
} from '@rover/react-lib/src/pages/landing/components/LandingHero';
import GroomingSearchForm from '@rover/react-lib/src/pages/landing/SeoLocation/templates/GroomingSeoLocation/components/GroomingSearchForm';
import {
  groomingHeroBackgroundDesktopImage,
  groomingHeroBackgroundTabletImage,
} from '@rover/react-lib/src/pages/landing/SeoLocation/templates/GroomingSeoLocation/images';
import type { ApiGroomingSearchRetrieveParams } from '@rover/rsdk/src/apiClient/latest/model/apiGroomingSearchRetrieveParams';

type Props = {
  h1: string;
  h2: string;
  searchParams: ApiGroomingSearchRetrieveParams;
};

const heroImages: HeroImageSrcSet = {
  desktop: {
    src: groomingHeroBackgroundDesktopImage,
    height: 500,
  },
  tablet: {
    src: groomingHeroBackgroundTabletImage,
    height: 500,
  },
};

const GroomingServiceLandingHero: FC<Props> = ({ h1, h2, searchParams }) => (
  <LandingHero mb="0x" heroImageSrcSet={heroImages} upliftedContent>
    <LandingHero.Content upliftedContent>
      <LandingHero.Display>{h1}</LandingHero.Display>
      <LandingHero.Text>{h2}</LandingHero.Text>
      <GroomingSearchForm key={searchParams.location} initialParams={searchParams} />
    </LandingHero.Content>
  </LandingHero>
);

export default GroomingServiceLandingHero;
